import React from 'react';
import { SpotlightOnNewApp } from '@material-bank/spotlight-on-new';
import { createRoot } from 'react-dom/client';

const root = 'new-experience-root';

function initializeApp() {
  const rootElement = document.getElementById(root);

  if (!rootElement) {
    const error = new Error(`Cannot find element with ID: ${root}`);
    console.error('Spotlight app render error:', error);

    return;
  }

  try {
    const root = createRoot(rootElement);

    root.render(<SpotlightOnNewApp />);
  } catch (error) {
    console.error('Spotlight app render error:', error);
  }
}

///
initializeApp();
